import React from "react";
import { NewParticipantContainer } from "../../../containers";

const NewParticipant = (props) => {
  return <NewParticipantContainer {...props} />;
};

export default NewParticipant;
